import { Layout } from '@roc/feature-app-core';
import { observer } from 'mobx-react';
import { Tabs } from '@roc/ui';
import { useExternalAgentLoansStore } from '../../../hooks/useExternalAgentLoansStore';
import { CompanyBankInformation } from './companyBankInformation';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';

const BANK_INFORMATION = 'BANK INFORMATION';

export const CompanyProfile = observer(() => {
  const { vendorCompanyProfileStore } = useExternalAgentLoansStore();
  const tabIndex = vendorCompanyProfileStore.selectedTabIndex;
  const { userStore } = useStore();
  const companyId = userStore.userInformation.companyId

  useEffect(() => {
    vendorCompanyProfileStore.getCompanyInformation(companyId);
  }, []);

  const onTabChange = (e, index) => {
    vendorCompanyProfileStore.setSelectedTabIndex(index);
  };

  const TABS = [
    {
      label: BANK_INFORMATION,
    },
  ];

  return (
    <Layout title="Company Profile" maxWidth={'lg'}>
      <Tabs tabs={TABS} selectedTab={tabIndex} onTabChange={onTabChange} />
      {TABS[tabIndex]?.label === BANK_INFORMATION && <CompanyBankInformation />}
    </Layout>
  );
});
